import React, { useEffect, useState } from "react";

// JS Files
import AppDownloadModal from "./AppDownloadModal";

// Others File

const AppDownloadCard = (props) => {
  const [openModal, setOpenModal] = useState(undefined);

  const handleOpenModal = () => {
    setOpenModal((before) => !before);
  };
  return (
    <>
      {openModal && (
        <AppDownloadModal openModal={openModal} setOpenModal={setOpenModal} />
      )}
      <div
        onClick={
          props.link
            ? () => window.open(props.link?.customer_app, "_blank")
            : props.pwaLink
            ? () => window.open(props.pwaLink, "_blank")
            : () => handleOpenModal()
        }
        className="border cursor-pointer border-mygray-500 rounded-lg py-2 px-4  flex items-center"
      >
        <div className="">
          <img src={props.icon} />
        </div>
        <div className="flex flex-col mr-4">
          <span className="text-sm text-mygray-700">{props.header}</span>
          <span className="mt-2">
            {props.isIcon ? (
              <img src={props.nameIcon} />
            ) : (
              <span className="font-bold text-mygray-700">{props.text}</span>
            )}
          </span>
        </div>
      </div>
    </>
  );
};
export default AppDownloadCard;
